/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Wpm_TitleInputs */

const en_summary_wpm_title = /** @type {(inputs: Summary_Wpm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words per minute`)
};

const fr_summary_wpm_title = /** @type {(inputs: Summary_Wpm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mots par minute`)
};

const de_summary_wpm_title = /** @type {(inputs: Summary_Wpm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wörter pro Minute`)
};

const it_summary_wpm_title = /** @type {(inputs: Summary_Wpm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parole al minuto`)
};

const ru_summary_wpm_title = /** @type {(inputs: Summary_Wpm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слова в минуту`)
};

const es_summary_wpm_title = /** @type {(inputs: Summary_Wpm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palabras por minuto`)
};

const zh_cn2_summary_wpm_title = /** @type {(inputs: Summary_Wpm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每分钟字数`)
};

const ja_summary_wpm_title = /** @type {(inputs: Summary_Wpm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分あたりの単語数`)
};

const hi_summary_wpm_title = /** @type {(inputs: Summary_Wpm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शब्द प्रति मिनट`)
};

const pt_pt2_summary_wpm_title = /** @type {(inputs: Summary_Wpm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palavras por minuto`)
};

/**
* | output |
* | --- |
* | "Words per minute" |
*
* @param {Summary_Wpm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_wpm_title = /** @type {((inputs?: Summary_Wpm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Wpm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_summary_wpm_title(inputs)
	if (locale === "de") return de_summary_wpm_title(inputs)
	if (locale === "it") return it_summary_wpm_title(inputs)
	if (locale === "ru") return ru_summary_wpm_title(inputs)
	if (locale === "es") return es_summary_wpm_title(inputs)
	if (locale === "zh-CN") return zh_cn2_summary_wpm_title(inputs)
	if (locale === "ja") return ja_summary_wpm_title(inputs)
	if (locale === "hi") return hi_summary_wpm_title(inputs)
	if (locale === "pt-PT") return pt_pt2_summary_wpm_title(inputs)
	return en_summary_wpm_title(inputs)
});